import React from "react";

const Folder = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-folder"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-folder"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m0,18V5C0,2.794,1.794,1,4,1h2c.464,0,.928.109,1.342.316l3.155,1.578c.138.069.293.105.447.105h5.056c2.757,0,5,2.243,5,5h-10.976c-2.638,0-5.003,1.766-5.754,4.303l-2.673,9.339c-.977-.913-1.597-2.203-1.597-3.642Zm23.493-6.983c-.479-.643-1.209-1.012-2.008-1.025-.015,0-.027.008-.042.008h-11.419c-1.758,0-3.335,1.177-3.834,2.862l-2.818,9.843c.513.178,1.055.295,1.628.295h12.558c2.226,0,4.15-1.432,4.802-3.607l1.532-6.116c.234-.782.089-1.605-.398-2.26Z" />
    </svg>
  );
};

export default Folder;
